export enum UserRole {
    ADMIN = 'ADMIN',
    USER = 'USER'
}

// Define the User type with first_name and last_name
// export interface User {
//   id: string;
//   email: string | null;
//   whatsapp_number: string | null;
//   first_name: string;
//   last_name: string;
//   role: UserRole;
//   isAuthenticated: boolean;
// }